import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';
import { ModalAddTradeAgreementComponent } from '../modal-add-trade-agreement/modal-add-trade-agreement.component';
import { ModalMessageComponent } from '../modal-message/modal-message.component';

@Component({
  selector: 'app-modal-view-role',
  templateUrl: './modal-view-role.component.html',
  styleUrls: ['./modal-view-role.component.scss']
})
export class ModalViewRoleComponent implements OnInit {

  checks: boolean[] = [];
  permissions: any = [];
  expandedIndex = 0;
  permissionsId: any = [];

  newRoleForm: FormGroup = new FormGroup({
    name_role: new FormControl('', Validators.required),
    display_name_role: new FormControl('', Validators.required),
  });

  changePermission(event: any, id: string){
    if(event.checked){
      this.permissionsId.push(id);
    }else{
      for (let index = 0; index < this.permissionsId.length; index++) {
        if(this.permissionsId[index] == id){
          this.permissionsId.splice(index, 1);
        }
      }
    }
  }

  setPermission(id: string){
    setTimeout(() => {
      this.checks[id] = true;
    }, 10);

  }

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private uService: UtilsService,
    private toast: ToastrService,
    private mService: MainService,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<ModalViewRoleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ){
    this.permissions = this.data.permissions;
    this.mService.get_request('rol/list/', { id: this.data.id })
    .subscribe((resp: any) =>{
      if(resp.status){
        var role: any = resp.items[Object.keys(resp.items)[0]];

        this.newRoleForm.get('name_role').setValue(role.role_name);
        this.newRoleForm.get('display_name_role').setValue(role.display_name);
        var localPermissions = role.permissions;
          for (const key in localPermissions) {
            localPermissions[key].forEach(permission => {
              this.permissionsId.push(permission.id);
              this.setPermission(permission.id);
            });
          }
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    });
    // this.newRoleForm.get('name_role').setValue(data.name);
    // this.newRoleForm.get('display_name_role').setValue(data.display_name);
    // this.permissions = data.permissions;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
  }

  dismiss(data?) {
    this.dialogRef.close( null );
  }
}

